import styled from 'styled-components';

export const CronContainer = styled.div`
	margin: 20px 50px;
	grid-area: cron;
`;

export const InfoText = styled.div`
	font-size: 13px;
	margin-top: 10px;
`;
